import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);

export default () => {
    // awards slider
    const awardsSwiper = new Swiper('.awards-slider', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        loop: false,
        a11y: true,
        keyboardControl: true,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 70,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 60,
            },
            1400: {
                slidesPerView: 4,
                spaceBetween: 60,
            },
        },
    });
};